import styled from '@emotion/styled'
import { theme } from '~/utils'

export const Container = styled.div`
  position: relative;
  display: flex;
  min-height: 400px;

  .slick-dots {
    position: absolute;
    left: 0px;
    display: flex !important;
    list-style: none;
    margin: 0;
    padding: 1.6rem 0 0 0;
    gap: .6rem;

    li button {
      border-radius: 50%;
      width: 14px;
      height: 14px;
      border: 0;
      text-indent: -99999px;
      cursor: pointer;
      opacity: 0.2;
    }

    li.slick-active button {
      background: #f9dc45;
      opacity: 1;
    }
  }

  .slick-slider {
    display: flex;
    flex: 1;
    height: 100%;
    margin: 0 24px;
    width: 360px !important;

    @media(max-width: ${theme.breakpoints.values.sm}px) {
      width: 200px !important;
    }
  }

  .slick-container {
    display: flex;
    flex: 1;
    height: 100%;
  }

  .slick-slide {
    display: flex;
    flex: 1;
    height: 100%;
    flex-direction: column;

    div {
      display: flex;
      flex: 1;
    }
  }

  .slick-list {
    display: flex;
    flex: 1;
    margin: 0 -24px;
  }

  .slick-track {
    display: flex !important;
    flex-direction: row;
    align-items: strech;
    width: 360px;
    flex: 1;
  }

  .slick-prev {
    right: 50px;
  }

  .slick-next {
    right: 0px;
  }

  .slick-arrow {
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 2;
    position: absolute;
    border: 0;
    border-radius: 50%;
    background: transparent;
    transition: background .1s ease-in-out;
    top: 10px;

    margin: auto 0;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: rgba(03,03,03,0.1);
    }
  }
`
